// eslint-disable-next-line @typescript-eslint/naming-convention
import DOMPurify from 'dompurify';
export class WCTranslate {
    constructor(obs) {
        this.translation = {};
        this.language = '';
        this.initTranslations();
        this.observer = obs;
        setInterval(this.watchLanguageChange.bind(this), 300);
    }
    watchLanguageChange() {
        if (this.language != this.getLang()) {
            this.initTranslations();
            this.language = this.getLang();
            this.observer.notifyObservers('langChange', this.language);
        }
    }
    translate(text, interpolations, allowedTags, allowedAttr) {
        const translation = this.translation[text] ? this.translation[text] : text;
        return interpolations
            ? Object.entries(interpolations).reduce((interpolated, [key, value]) => interpolated.replace(`$${key}$`, DOMPurify.sanitize(value, {
                ALLOWED_TAGS: ['#text', ...(allowedTags ?? [])],
                ALLOWED_ATTR: allowedAttr || [],
            })), translation)
            : translation;
    }
    getLang() {
        if (window['CONST_LANG']) {
            if (window['CONST_LANG']?.shortcode &&
                ['en', 'es', 'de', 'it', 'fr'].includes(window['CONST_LANG']?.shortcode)) {
                return window['CONST_LANG'].shortcode;
            }
            else if (typeof window['CONST_LANG'] === 'string' &&
                window['CONST_LANG']?.length === 2 &&
                ['en', 'es', 'de', 'it', 'fr'].includes(window['CONST_LANG'])) {
                return window['CONST_LANG'];
            }
        }
        else {
            if (window?.navigator?.language &&
                ['en', 'es', 'de', 'it', 'fr'].includes(window?.navigator?.language)) {
                return window.navigator.language;
            }
            else {
                return 'en';
            }
        }
    }
    initTranslations(locale) {
        // Get lang
        locale = locale || this.getLang();
        const languages = {
            /* eslint-disable @typescript-eslint/no-require-imports */
            fr: require('./../../lang/fr.json'),
            en: require('./../../lang/en.json'),
            de: require('./../../lang/de.json'),
            it: require('./../../lang/it.json'),
            es: require('./../../lang/es.json'),
            /* eslint-enable @typescript-eslint/no-require-imports */
        };
        this.translation = languages[locale] || languages['en'];
    }
}
